import { Button, Flex } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './GeneralButton.css'
import { useNavigate } from 'react-router-dom';

function GeneralButton(props) {

    let navigate = useNavigate();

    return (

    <Flex direction="row">
          

        { props.width == null ? (
            <Button
                className='businessButton'
                variation="primary" colorTheme="landing"
                isFullWidth={false}
                loadingText=""
                marginTop={{ base: "1em", medium: "1em", large: "1em" }}
                // marginLeft={{ base: "1em", medium: "1em", large: "1em" }}
                marginRight={{ base: "1em", medium: "1em", large: "1em" }}
                onClick={() => {
                    console.log(props.state);
                    navigate(props.url, { state: props.state });
                }}
                
                width={{ base: "250px", medium: "250px", large: "250px" }}
                fontWeight={"bold"}
            >
                {props.text}
            </Button>
        ) : (
            <Button
                className='businessButton'
                variation="primary" colorTheme="landing"
                isFullWidth={false}
                loadingText=""
                //marginTop={{ base: "1em", medium: "1em", large: "1em" }}
                //marginLeft={{ base: "1em", medium: "1em", large: "1em" }}
                //marginRight={{ base: "1em", medium: "1em", large: "1em" }}
                onClick={() => navigate(props.url, { state: props.state })} 
                width={{ base: props.width, medium: props.width, large: props.width }}
                fontWeight={"bold"}
            >
                {props.text}
            </Button>
        )}
    </Flex>
    );
};

export default GeneralButton;
